import React from "react";
import { defer, redirect, useLoaderData, useRouteLoaderData } from "react-router-dom"
import { createfollowupInspection, createInspection, removeInspection, updateInspection } from "@app/models/inspection"
import {
	needsNextStepValidation,
	nextStep,
	nextStepRedirect,
	previousStepRedirect
} from "@app/utils/inspection"
import FormStepContainer from "@app/components/inspection-form/FormStepContainer.jsx";
import InspectionSyncState from "@app/components/InspectionSyncState";
import Config from "@app/constants/Config";
import { getInspectionConfig } from "@app/models/inspectionConfig"
import { getInstantValidation } from "@app/utils/form"
import SignsOverlayButton from "@app/components/SignsOverlayButton"

let pendingAction = null;

const instantValidation = async (values, step) => {
	const inspectionConfig = await getInspectionConfig();
	const formStep = inspectionConfig?.forms?.steps?.[step - 1]
	return getInstantValidation(values, formStep.fieldsets)
}


export const updateInspectionAction = async ({ request, params }) => {
    const { inspectionId } = params;
    const formData = await request.formData();
    const data = await JSON.parse(formData.get("json"));
    const action = formData.get("action") || "SUBMIT";
    const type = formData.get("type") || "INITIAL";

    // update inspection
    const step = parseInt(params.step, 10);
    const { saveAsync } = await updateInspection(inspectionId, data, step, type);
	pendingAction = saveAsync;

const validationRes = await instantValidation(data, step);
	let {isInstantValid, errors} = validationRes;

if (step === 4 && action !== "SAVE" && action !== "PREVIOUS") {
		const gefaehrdungen = data.physischegefaehrdungsanalyse_gefaehrdungen_gefaehrdungen;
		if (!Array.isArray(gefaehrdungen) || gefaehrdungen.length < Config.DANGER_MIN_COUNT) {
			errors.push({
				path: "physischegefaehrdungsanalyse_gefaehrdungen_gefaehrdungen",
				type: "minCount",
				value: gefaehrdungen,
			});
			isInstantValid = false;
		}
	}

    	switch(action) {
        case "SAVE":
			if (!isInstantValid) {
				return {
					type: "FORM_ERROR",
					reason: "Inputs required to proceed",
					key: "INSTANTLY_REQUIRED_INPUTS",
					errors,
				}
			}
            return true
        case "PREVIOUS":
            return previousStepRedirect(step, inspectionId)
        case "NAVIGATE":
			const isPrev = needsNextStepValidation(step, formData.get('navigateTarget'));
			if (!isInstantValid) {
				return {
					type: "FORM_ERROR",
					reason: "Inputs required to proceed",
					key: "INSTANTLY_REQUIRED_INPUTS",
					errors,
				}
			}
			return redirect(formData.get('navigateTarget'));
		case "NEW_AND_DELETE":
			await removeInspection(inspectionId)
			return redirect('/inspection/new-initial');
        default:
			if (!isInstantValid) {
				return {
					type: "FORM_ERROR",
					reason: "Inputs required to proceed",
					key: "INSTANTLY_REQUIRED_INPUTS",
					errors,
				}
			}
            return nextStepRedirect(step, inspectionId)
    }
};

const newAction = async (type, { request }) => {
    const formData = await request.formData();
    const data = await JSON.parse(formData.get("json"));

	const validationRes = await instantValidation(data, 1);
	const {isInstantValid, errors} = validationRes;
	if (!isInstantValid) {
		return {
			type: "FORM_ERROR",
			reason: "Inputs required to proceed",
			key: "INSTANTLY_REQUIRED_INPUTS",
			errors,
		}
	}

    // create a new inspection
    const { uuid, saveAsync } = await createInspection(data, type);
	pendingAction = saveAsync;
    const replacePath = await nextStep("new", uuid);
    // enable proper back browser navigation
    window.history.replaceState(null, "", replacePath);
    return nextStepRedirect(1, uuid);
};

export const newInitialAction = async (req) => {
    return newAction("INITIAL", req);
};

export const newFollowUpAction = async ({ request, params }) => {
	const { inspectionId: initialUUID } = params
	const formData = await request.formData()
	const data = await JSON.parse(formData.get("json"))
	const action = formData.get("action");

	if (action === "NEW_AND_DELETE") return redirect('/inspection/new-initial');

	const { uuid, saveAsync } = await createfollowupInspection(data, initialUUID)
	pendingAction = saveAsync

	const replacePath = await nextStep("new", uuid)
	// enable proper back browser navigation
	window.history.replaceState(null, "", replacePath)
	return nextStepRedirect(1, uuid)
}

export async function loader (request) {
    const {
        params: { step, inspectionId }
    } = request;

    if (inspectionId && !step) {
        return redirect(`${Config.BASE_PATH}/inspection/${inspectionId}/1`);
    }

    document.body.scrollIntoView({ behavior: "smooth" }); // @todo: unsure if right spot
    const res = defer({
        syncRequest: inspectionId ? pendingAction?.() : undefined,
    });
    pendingAction = null;
    return res;
}

export default function InspectionFormStep () {
    const { inspection, office } = useRouteLoaderData("inspection");
    const { syncRequest } = useLoaderData();

	if(location?.hash?.length > 0) {
		document.querySelector(location?.hash)?.scrollIntoView({ behavior: "smooth" })
	}

    return (
            <>
                <InspectionSyncState syncRequest={syncRequest} />
                {/*pendingAction: {pendingAction}*/}
				<SignsOverlayButton />
                <FormStepContainer officeData={office} inspection={inspection} />
            </>
    );
}
